import { Card } from "antd";
import React from "react";

const RightToInformation = () => {
  return (
    <Card title="नागरिकांची सनद">
      <div>
        <a
          style={{ color: "#0d6efd", fontSize: 16 }}
          target="_blank"
          href="https://pskagal.in/api/uploads/sanad/sanad_kagal.pdf"
        >
          नागरिकांची सनद, पंचायत समिती, कागल
        </a>
      </div>
      <div>
        <a
          style={{ color: "#0d6efd", fontSize: 16 }}
          target="_blank"
          href="https://pskagal.in/api/uploads/sanad/sanad.pdf"
        >
          नागरिकांची सनद-शासन निर्णय
        </a>
      </div>

      <h3>पंचायत समिती, कागल</h3>
    </Card>
  );
};

export default RightToInformation;
